import { z } from "zod";

export const EngagementLevel = z.enum(["poor", "average", "good"]);
export const EngagementLevelList = EngagementLevel.options;
export type EngagementLevel = z.infer<typeof EngagementLevel>;

export const EngagementLevelMap: Record<EngagementLevel, string> = {
    poor: "Poor",
    average: "Average",
    good: "Good",
};
